'use strict';

var markerIcon;

if (typeof google === 'undefined') {
	// This is likely because offline.
	// Above line uses typeof because we don't know if the variable was declared or not
	console.warn('google object not defined.');
} else {
	markerIcon = {
	default: {
		path: 'M93.9,62.6L61,132.7c-1.8,3.7-6,6.5-10.2,6.5s-8.3-2.3-10.2-6.5L7.8,62.6C5.1,57.5,4.6,52,4.6,46.4C4.6,20.9,25.4,0,50.9,0 s46.2,20.9,46.2,46.4C97.1,52,96.2,57.5,93.9,62.6z M50.9,23.2c-12.9,0-23.1,10.2-23.1,23.2s10.2,23.2,23.1,23.2S74,59.4,74,46.4 S63.3,23.2,50.9,23.2z',
		fillColor: '#27a45b',
		fillOpacity: 1,
		anchor: new google.maps.Point(52, 140),
		scale: .35
	}
	};
}


module.exports = {
    icon: markerIcon
};
